import { FontAwesome } from "@expo/vector-icons";

const CARD_BRAND_ICONS: { [key: string]: keyof typeof FontAwesome.glyphMap } = {
  Visa: "cc-visa",
  MasterCard: "cc-mastercard",
  "American Express": "cc-amex",
  Discover: "cc-discover",
  JCB: "cc-jcb",
  "Diners Club": "cc-diners-club",
  UnionPay: "credit-card",
};

export const getCreditCardIcon = (
  brand: string,
): keyof typeof FontAwesome.glyphMap =>
  CARD_BRAND_ICONS[brand] ?? "credit-card";

// Wallet brand names are trademarks and are not translated.
export const walletTypeLabel = (walletType: string | null): string | null =>
  walletType === "apple_pay"
    ? "Apple Pay"
    : walletType === "google_pay"
      ? "Google Pay"
      : null;
